// @ts-nocheck
import React, { memo } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

import { Footer, Header, SubHeader } from "components";
import { handlerScrollUp, posTop } from "utils";

import "../styles/styles.scss";
import "tailwindcss/tailwind.css";

import LoginGuard from "admin/src/containers/LoginGuard";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DayjsUtils from "@date-io/dayjs";
import Menu from "admin/src/components/Menu/index";

const MyApp = ({ Component, pageProps }) => {
  const queryClient = new QueryClient();
  const pageView = (event) => {
    window &&
      window.dataLayer &&
      window.dataLayer.push({
        event: event,
      });
  };

  queryClient.setDefaultOptions({
    queries: {
      refetchInterval: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
    },
  });

  return (
    <>
      {!pageProps?.isAdminPage && (
        <script src="//code.jivo.ru/widget/oEnwWX7boW" async></script>
      )}
      <QueryClientProvider client={queryClient}>
        {pageProps?.isAdminPage && (
          <div className={"w-full h-full"}>
            <MuiPickersUtilsProvider utils={DayjsUtils}>
              <LoginGuard>
                <Menu>
                  <Component {...pageProps} />
                </Menu>
              </LoginGuard>
            </MuiPickersUtilsProvider>
          </div>
        )}

        {!pageProps?.isAdminPage && (
          <section className={`app_main`}>
            <div className={"app_main-wrapper"}>
              <Header />
              <SubHeader />
              <Component {...pageProps} pageView={pageView} />
              <Footer />
              {posTop() > 400 && (
                <div onClick={handlerScrollUp} className="go_top">
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.6665 30L26.6665 20L16.6665 10"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
          </section>
        )}
      </QueryClientProvider>
    </>
  );
};

export default memo(MyApp);
